import { z } from '@harvestiq/zod';

import { zIsoDate } from '@harvestiq/zod';

export enum BreakevenOperationTypes {
  BACKGROUNDING = 'Backgrounding',
  FEEDYARD = 'Feedyard',
}

export const getBreakevenCalculationSchema = z.object({
  operationType: z.coerce.string().pipe(z.nativeEnum(BreakevenOperationTypes)),
  contractDate: zIsoDate(),
});

export type GetBreakevenCalculationRequest = z.infer<
  typeof getBreakevenCalculationSchema
>;

export const getBreakevenCalculationResponseSchema = z.object({
  data: z.object({
    cmeContract: z.number(),
    contractMonth: z.string(),
    salesDate: z.string(),
    symbol: z.string(),
  }),
});

export type GetBreakevenCalculationResponse = z.infer<
  typeof getBreakevenCalculationResponseSchema
>;
